import EnabledDoubleSideModal from './EnabledDoubleSideModal';
export default EnabledDoubleSideModal;
